// import Vue from 'vue'
// import store from '../store/index';
// import Router from 'vue-router'
// import Layout from '../js/components/layout/Layout.vue';
// import AuthLayout from '../js/components/layout/AuthLayout.vue';
// import ReferenceBookGenres from '../js/components/views/organizers/ReferenceBookGenres.vue';
// import ReferenceBookNominations from '../js/components/views/organizers/ReferenceBookNominations.vue';
// import ReferenceBookAgeCategories from '../js/components/views/organizers/ReferenceBookAgeCategories.vue';
// import ReferenceBookGroups from '../js/components/views/organizers/ReferenceBookGroups.vue';
// import Festivals from '../js/components/views/organizers/Festivals.vue';
// import FestivalPrograms from '../js/components/views/organizers/FestivalPrograms.vue';
// import FestivalMarksAndJudges from '../js/components/views/organizers/FestivalMarksAndJudges.vue';
// import Settings from '../js/components/views/organizers/Settings.vue';
// import Finances from '../js/components/views/organizers/Finances.vue';
// import Translate from '../js/components/views/organizers/Translate.vue'; // todo
// import FestivalCardApplications from '../js/components/views/organizers/FestivalCardApplications.vue';
// import FestivalScreens from '../js/components/views/organizers/FestivalScreens.vue';
// import FestivalDiplomas from '../js/components/views/organizers/FestivalDiplomas.vue';
// import Participants from '../js/components/views/organizers/Participants.vue';
// import UserProfile from '../js/components/views/users/UserProfile.vue';
// import Dashboard from '../js/components/views/users/Dashboard.vue';
// import Application from '../js/components/views/applications/Application.vue';
// import AllApplications from '../js/components/views/applications/AllApplications.vue';
// import FestivalSettings from "../js/components/views/organizers/FestivalSettings.vue";
// import DiplomaBuilder from "../js/components/views/organizers/DiplomaBuilder.vue";
// import PublicFestivalPrograms from "../js/components/views/public/FestivalPrograms.vue";
// import CompetitionProgram from "../js/components/views/public/CompetitionProgram.vue";
// import Screen from "../js/components/views/public/Screen.vue";
// import ProgramsList from "../js/components/views/juries/ProgramsList.vue";
// import ProgramApplication from "../js/components/views/juries/ProgramApplication.vue";
// import StageManager from "../js/components/views/stageManager/StageManager.vue";
// import UserAuthBySecret from "../js/components/views/admins/UserAuthBySecret.vue";
// import AdminDashboard from "../js/components/views/admins/AdminDashboard.vue";
// import Users from "../js/components/views/admins/Users.vue";
// import ResellerDashboard from "../js/components/views/resellers/ResellerDashboard.vue";
// import NotFoundComponent from "../js/components/views/errors/404.vue";

import Vue from 'vue'
import store from '../store/index';
import Router from 'vue-router'

const FestivalPremium = () => import('../js/components/views/organizers/FestivalPremium.vue');
const PaymentCategories = () => import('../js/components/views/organizers/PaymentCategories.vue');
const Tags = () => import('../js/components/views/organizers/Tags.vue');
const Certificates = () => import('../js/components/views/organizers/Certificates.vue');


const Layout = () => import('../js/components/layout/Layout.vue');
const Embed = () => import('../js/components/layout/Embed.vue');
const AuthLayout = () => import(  '../js/components/layout/AuthLayout.vue');
const EmailTemplates = () => import(  '../js/components/views/organizers/EmailTemplates.vue');
const EmailCampaigns = () => import(  '../js/components/views/organizers/EmailCampaigns.vue');
const EmailCampaign = () => import(  '../js/components/views/organizers/EmailCampaign.vue');
const ThingGroups = () => import(  '../js/components/views/organizers/ThingGroups.vue');
const Things = () => import(  '../js/components/views/organizers/Things.vue');
const UserLists = () => import(  '../js/components/views/organizers/UserLists.vue');
const UserList = () => import(  '../js/components/views/organizers/UserList.vue');
const ReferenceBook = () => import(  '../js/components/views/organizers/ReferenceBook.vue');
const ReferenceBookItems = () => import(  '../js/components/views/organizers/ReferenceBookItems.vue');
const Festivals = () => import(  '../js/components/views/organizers/Festivals.vue');
const Payments = () => import(  '../js/components/views/organizers/Payments.vue');
const FestivalPrograms = () => import(  '../js/components/views/organizers/FestivalPrograms.vue');
const FestivalMarksAndJudges = () => import(  '../js/components/views/organizers/FestivalMarksAndJudges.vue');
const Settings = () => import(  '../js/components/views/organizers/Settings.vue');
const Finances = () => import(  '../js/components/views/organizers/Finances.vue');
const Translate = () => import(  '../js/components/views/organizers/Translate.vue'); // todo
const FestivalCardApplications = () => import(  '../js/components/views/organizers/FestivalCardApplications.vue');
const FestivalScreens = () => import(  '../js/components/views/organizers/FestivalScreens.vue');
const FestivalDiplomas = () => import(  '../js/components/views/organizers/FestivalDiplomas.vue');
const Participants = () => import(  '../js/components/views/organizers/Participants.vue');
const Participant = () => import(  '../js/components/views/organizers/Participant.vue');
const Orders = () => import(  '../js/components/views/organizers/Orders.vue');
const UserProfile = () => import(  '../js/components/views/users/UserProfile.vue');
const Dashboard = () => import(  '../js/components/views/users/Dashboard.vue');
const ManageFiles = () => import(  '../js/components/views/organizers/ManageFiles.vue');
const Application = () => import(  '../js/components/views/applications/Application.vue');
// const AllApplications = () => import(  '../js/components/views/applications/AllApplications.vue');
const FestivalSettings = () => import(  "../js/components/views/organizers/FestivalSettings.vue");
const FestivalReports = () => import(  "../js/components/views/organizers/FestivalReports.vue");
const HelpCenter = () => import(  "../js/components/views/organizers/HelpCenter.vue");
const DiplomaBuilder = () => import(  "../js/components/views/organizers/DiplomaBuilder.vue");
const EmailBuilder = () => import(  "../js/components/views/organizers/EmailBuilder.vue");
const ApplicationBuilder = () => import(  "../js/components/views/organizers/ApplicationBuilder.vue");
const Post = () => import(  "../js/components/views/organizers/Post.vue");
const PublicFestivalPrograms = () => import(  "../js/components/views/public/FestivalPrograms.vue");
const PublicReport = () => import(  "../js/components/views/public/PublicReport.vue");
const PublicProgram = () => import(  "../js/components/views/public/PublicProgram.vue");
const Screen = () => import(  "../js/components/views/public/Screen.vue");
const ProgramsList = () => import(  "../js/components/views/juries/ProgramsList.vue");
const ProgramApplication = () => import(  "../js/components/views/juries/ProgramApplication.vue");
const StageManager = () => import(  "../js/components/views/stageManager/StageManager.vue");
const UserAuthBySecret = () => import(  "../js/components/views/admins/UserAuthBySecret.vue");
const AdminDashboard = () => import(  "../js/components/views/admins/AdminDashboard.vue");
const AdminHelpCenterPostEditing = () => import(  "../js/components/views/admins/AdminHelpCenterPostEditing.vue");
const AdminHelpCenter = () => import(  "../js/components/views/admins/AdminHelpCenter.vue");
const PostEditing = () => import(  "../js/components/views/admins/PostEditing.vue");
const Posts = () => import(  "../js/components/views/admins/Posts.vue");
const Users = () => import(  "../js/components/views/admins/Users.vue");
const CrmClient = () => import(  "../js/components/views/admins/CrmClient.vue");
const CrmClients = () => import(  "../js/components/views/admins/CrmClients.vue");
const CrmTasks = () => import(  "../js/components/views/admins/CrmTasks.vue");
const ResellerDashboard = () => import(  "../js/components/views/resellers/ResellerDashboard.vue");
const WaitingSocialAuth = () => import(  "../js/components/layout/WaitingSocialAuth.vue");
const NotFoundComponent = () => import(  "../js/components/views/errors/NotFoundComponent.vue");
const PrivacyPolicy = () => import(  "../js/components/views/public/PrivacyPolicy.vue");
const TermsOfUse = () => import(  "../js/components/views/public/TermsOfUse.vue");
const PublicEmailConfirmation = () => import(  "../js/components/views/public/PublicEmailConfirmation.vue");
const WidgetPage = () => import(  "../js/components/views/public/WidgetPage.vue");
const TableComponent = () => import(  "../js/components/customComponents/tableComponents/TableComponent.vue");
// const VKWidget = () => import(  "../js/components/widgets/VKWidget.vue");



Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Root',
            redirect: '/webapp',
        },
        {
            path: '/webapp/embed',
            name: 'Embed',
            component: Embed,

            children: [
                {
                    path: 'organizer/applications/:applicationId',
                    name: 'EmbedOrganizerApplication',
                    component: Application,
                },
            ]
        },
        {
            path: '/webapp',
            name: 'Main',
            component: Layout,

            children: [
                {
                    path: 'organizer/user-lists',
                    name: 'organizerUserLists',
                    component: UserLists
                },
                {
                    path: 'organizer/user-lists/:id',
                    name: 'organizerUserList',
                    component: UserList
                },
                {
                    path: 'organizer/reference-book',
                    name: 'organizerReferenceBook',
                    component: ReferenceBook
                },
                {
                    path: 'organizer/posts/:postId',
                    name: 'organizerPost',
                    component: Post
                },
                {
                    path: 'festival/:festivalId/tableComponent', // todo временный роут. потом это надо будет вынести в таблицу отдельную или нет.
                    name: 'organizerTableComponent',
                    component: TableComponent
                },
                {
                    path: 'organizer/reference-book/:referenceBookId',
                    name: 'organizerReferenceBookItems',
                    component: ReferenceBookItems
                },
                // {
                //     path: 'organizer/reference-book/groups',
                //     name: 'organizerReferenceBookGroups',
                //     component: ReferenceBookGroups
                // },
                {
                    path: 'organizer/email-templates',
                    name: 'organizerEmailTemplates',
                    component: EmailTemplates
                },

                {
                    path: 'organizer/email-campaigns',
                    name: 'organizerEmailCampaigns',
                    component: EmailCampaigns
                },

                {
                    path: '/webapp/organizer/email-campaigns/:id',
                    name: 'organizerEmailCampaign',
                    component: EmailCampaign,
                },

                {
                    path: 'organizer/things',
                    name: 'organizerThingsGroups',
                    component: ThingGroups
                },
                {
                    path: 'organizer/things/:thingGroupId',
                    name: 'organizerThings',
                    component: Things
                },
                {
                    path: 'organizer/festivals',
                    name: 'organizerFestivals',
                    component: Festivals
                },
                {
                    path: 'organizer/payments',
                    name: 'organizerPayments',
                    component: Payments
                },
                {
                    path: 'organizer/paymentCategories',
                    name: 'organizerPaymentCategories',
                    component: PaymentCategories
                },
                {
                    path: 'organizer/tags',
                    name: 'organizerTags',
                    component: Tags
                },
                {
                    path: 'organizer/certificates',
                    name: 'organizerCertificates',
                    component: Certificates
                },
                {
                    path: 'organizer/festival/:festivalId/applications',
                    name: 'organizerFestivalCardApplications',
                    component: FestivalCardApplications
                },
                {
                    path: 'organizer/festival/:festivalId/programs',
                    name: 'organizerFestivalCardPrograms',
                    component: FestivalPrograms
                },
                {
                    path: 'organizer/festival/:festivalId/festivalMarksAndJudges',
                    name: 'organizerFestivalMarksAndJudges',
                    component: FestivalMarksAndJudges
                },
                {
                    path: 'organizer/festival/:festivalId/premium',
                    name: 'organizerFestivalPremium',
                    component: FestivalPremium
                },
                {
                    path: 'organizer/festival/:festivalId/festivalScreens',
                    name: 'organizerFestivalScreens',
                    component: FestivalScreens
                },
                {
                    path: 'organizer/festival/:festivalId/festivalDiplomas',
                    name: 'organizerFestivalDiplomas',
                    component: FestivalDiplomas
                },
                {
                    path: 'organizer/festival/:festivalId/settings',
                    name: 'organizerFestivalCardSettings',
                    component: FestivalSettings
                },
                {
                    path: 'organizer/festival/:festivalId/festivalReports',
                    name: 'organizerFestivalReports',
                    component: FestivalReports
                },
                {
                    path: 'organizer/finances',
                    name: 'organizerFinances',
                    component: Finances
                },
                {
                    path: 'organizer',
                    name: 'organizerDashboard',
                    component: Dashboard,
                },
                {
                    path: 'organizer/profile',
                    name: 'organizerProfile',
                    component: UserProfile
                },
                {
                    path: 'organizer/manageFiles',
                    name: 'organizerManageFiles',
                    component: ManageFiles
                },
                {
                    path: 'organizer/applications/:applicationId',
                    name: 'organizerApplication',
                    component: Application,
                },
                // {
                //     path: 'organizer/applications',
                //     name: 'organizerApplications',
                //     component: AllApplications,
                // },
                {
                    path: 'organizer/participants',
                    name: 'organizerParticipants',
                    component: Participants,
                },
                {
                    path: 'organizer/participants/:id',
                    name: 'organizerParticipant',
                    component: Participant,
                },
                {
                    path: 'organizer/orders',
                    name: 'organizerOrders',
                    component: Orders,
                },
                {
                    path: 'organizer/helpCenter/:categoryId?',
                    name: 'organizerHelpCenter',
                    component: HelpCenter,
                },
                {
                    path: 'organizer/settings',
                    name: 'organizerSettings',
                    component: Settings,
                },
                {
                    path: 'user/profile',
                    name: 'userProfile',
                    component: UserProfile
                },
                {
                    path: 'user',
                    name: 'userDashboard',
                    component: Dashboard,
                },
                {
                    path: 'user/applications/:applicationId',
                    name: 'userApplication',
                    component: Application,
                },
                // {
                //     path: 'user/applications',
                //     name: 'userApplications',
                //     component: AllApplications,
                // },
                {
                    path: 'translate',
                    name: 'Translate',
                    component: Translate,
                },

                // Админские роуты
                {
                    path: 'superAdmin',
                    name: 'adminDashboard',
                    component: CrmTasks,
                },
                {
                    path: 'superAdmin/AdminHelpCenterPostEditing/:helpPostId',
                    name: 'AdminHelpCenterPostEditing',
                    component: AdminHelpCenterPostEditing,
                },
                {
                    path: 'superAdmin/adminHelpCenter',
                    name: 'adminHelpCenter',
                    component: AdminHelpCenter,
                },
                {
                    path: 'superAdmin/posts',
                    name: 'adminPosts',
                    component: Posts,
                },
                {
                    path: 'superAdmin/posts/:postId',
                    name: 'adminPostEditing',
                    component: PostEditing,
                },
                {
                    path: 'superAdmin/users',
                    name: 'adminUsers',
                    component: Users,
                },
                {
                    path: 'superAdmin/crm/clients',
                    name: 'adminCrmClients',
                    component: CrmClients,
                },
                {
                    path: 'superAdmin/crm/clients/:clientId',
                    name: 'adminCrmClient',
                    component: CrmClient,
                },
                {
                    path: 'superAdmin/crm/tasks',
                    name: 'adminCrmTasks',
                    component: CrmTasks,
                },

                // Админские роуты
                {
                    path: 'reseller',
                    name: 'resellerDashboard',
                    component: ResellerDashboard,
                },
            ]
        },


        {
            path: '/webapp/organizer/email-templates/:templateId',
            name: 'organizerEmailTemplate',
            component: EmailBuilder,
        },


        // Diplomas
        {
            path: '/webapp/organizer/festival/:festivalId/diplomaBuilder/:diplomaId',
            name: 'organizerDiplomaBuilder',
            component: DiplomaBuilder,
        },
        {
            path: '/webapp/organizer/festival/:festivalId/applicationBuilder',
            name: 'organizerApplicationBuilder',
            component: ApplicationBuilder,
        },

        // Auth routes
        {
            path: '/webapp/organizer/auth',
            name: 'organizerAuth',
            redirect: '/webapp/login',
        },
        {
            path: '/webapp/user/:organizerSlug/login',
            name: 'userAuth',
            redirect: '/webapp/login',
        },
        // Для старых маршрутов -  удалить у северной  и артвей
        {
            path: '/organizer/auth',
            name: 'organizerAuthOld',
            component: AuthLayout,
        },
        {
            path: '/user/:organizerSlug/login',
            name: 'userAuthOld',
            component: AuthLayout,
        },
        // !Для старых маршрутов
        {
            path: '/webapp/login',
            name: 'auth',
            component: AuthLayout,
        },
        {
            path: '/webapp/fastLogin/:slug/:redirectType?/:redirectValue?',
            name: 'UserAuthBySecret',
            component: UserAuthBySecret,
        },
        {
            path: '/webapp/auth/waitingSocialAuth/:provider',
            name: 'WaitingSocialAuth',
            component: WaitingSocialAuth,
        },

        // StageManager routes
        {
            path: '/webapp/StageManager/:stageManagerSlug',
            name: 'StageManager',
            component: StageManager,
        },

        // Jury routes
        {
            path: '/webapp/jury',
            name: 'juryProgramsList',
            component: ProgramsList,
        },
        {
            path: '/webapp/jury/program/:programId',
            name: 'juryProgramApplication',
            component: ProgramApplication,
        },

        // Public routes
        // {
        //     path: '/webapp/public/CompetitionProgram/:festivalId/:programId/:mode?',
        //     name: 'PublicCompetitionProgram',
        //     component: CompetitionProgram,
        // },
        {
            path: '/webapp/public/screen/:screenSlug',
            name: 'Screen',
            component: Screen,
        },
        {
            path: '/webapp/public/PublicFestivalPrograms/:festivalId',
            name: 'PublicFestivalPrograms',
            component: PublicFestivalPrograms,
        },
        {
            path: '/webapp/public/publicReport/:reportViewId',
            name: 'PublicReport',
            component: PublicReport,
        },
        {
            path: '/webapp/public/publicProgram/:programViewId',
            name: 'PublicProgram',
            component: PublicProgram,
        },
        {
            path: '/webapp/public/privacyPolicy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy,
        },
        {
            path: '/webapp/public/PublicEmailConfirmation/:token',
            name: 'PublicEmailConfirmation',
            component: PublicEmailConfirmation,
        },
        {
            path: '/webapp/public/termOfUse',
            name: 'TermsOfUse',
            component: TermsOfUse,
        },
        {
            path: '/webapp/public/application/:festivalUuid',
            name: 'WidgetPage',
            component: WidgetPage,
        },
        // {
        //     path: '/webapp/widgets/VKWidget',
        //     name: 'VKWidget',
        //     component: VKWidget,
        // },

        {path: '*', component: NotFoundComponent}
    ]
});

router.beforeEach((to, from, next) => {

    if (to.name === 'userAuthOld') {
        let self = this;

        axios.get(window.apiUrl + '/api/init/getSiteByOrganizer?slug=' + to.params.organizerSlug).then(function (response) {
            if (response.data.domain) {
                window.location.href = 'https://' + response.data.domain;
            }
        });
    }

    // Если страна не выбрана , значит профиль не заполнен. Переадресация на профиль.
    if (window.enableCheckProfile) {
        if (to.name !== 'userProfile' && to.name !== 'organizerProfile' && store.getters.getCurrentUser && +store.getters.getCurrentUser.country.id === 219) {
            next({name: store.getters.getCurrentUser.role === 'user' ? 'userProfile' : 'organizerProfile'});
        }
    }

    // Главная страница, кидаем в зависимости от роли
    if ((to.name === 'Main' || to.name === 'Root') && store.getters.getCurrentUser) {
        let currentUser = store.getters.getCurrentUser;
        let name = 'Root';

        if (currentUser.role === 'organizer') {
            name = 'organizerDashboard';
        } else if (currentUser.role === 'user') {
            name = 'userDashboard';
        } else if (currentUser.role === 'superAdmin') {
            name = 'adminDashboard';
        } else if (currentUser.role === 'reseller') {
            name = 'resellerDashboard';
        } else if (currentUser.role === 'jury') {
            name = 'juryProgramsList';
        }

        next({name: name})
    }

    // Проверяем есть ли токен и набо ли отправить на страницу авторизации
    if (
        to.name !== 'auth'
        && to.name !== 'userAuthOld'
        && to.name !== 'UserAuthBySecret'
        && to.name !== 'WaitingSocialAuth'
        && to.name !== 'StageManager'
        && to.path.indexOf('/public/') === -1
        && to.path.indexOf('/widgets/') === -1
        && !localStorage.getItem('authToken')
    ) {
        next({name: 'auth'})
    } else {
        if (to.name === 'auth' && localStorage.getItem('authToken')) {
            next({name: 'Root'})
        }
    }

    next()

})


export default router;
